import React, { Component } from 'react';
import CtaSidebar from './CtaSidebar';
import data from '../data/dataEN.json';

class Person extends Component {
  constructor({ match }) {
    super();
    const service = data.services.core_services.find(({ slug }) => slug === match.params.slug);

    this.state = {
      service,
      cta: data.cta.sidebar,
      services: data.services.core_services,
    };
  }

  render() {
    return (
      <div>
        <div className="business-banner">
          <div className="hvrbox">
            <img src={this.state.service.bgImg} alt={this.state.service.title} className="hvrbox-layer_bottom" />
            <div className="hvrbox-layer_top">
              <div className="container">
                <div className="overlay-text text-left">
                  <h3>{this.state.service.title}</h3>
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <a href="/">Home</a>
                      </li>
                      <li className="breadcrumb-item active" aria-current="page">
                        <a href="/services-en">Services</a>
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="padding-top-large" /> */}

        <div className="bussiness-about-company">
          <div className="container">
            <div className="row">
              <div className="col-md-9">
                <div className="about-company-left">
                  <h2>{this.state.service.title}</h2>
                  <h3>{this.state.service.desc}</h3>
                  {this.state.service.illustration ? (
                    <div>
                      <div className="padding-top-middle" />
                      <img src={this.state.service.illustration} alt={this.state.service.title} className="img-fluid" />
                    </div>
                  ) : (
                    ''
                  )}

                  <div className="padding-top-middle" />

                  <div dangerouslySetInnerHTML={{ __html: this.state.service.body }} />

                  <div className="padding-top-middle" />

                  {this.state.service.keywords ? (
                    <div className="business-tag">
                      <h3>Tags:</h3>
                      {this.state.service.keywords.map(keyword => <a href="/contact-us">{keyword}</a>)}
                    </div>
                  ) : (
                    ''
                  )}
                </div>
                <div className="padding-top-large" />
              </div>
              <div className="col-md-3">
                <div className="padding-top-large" />
                <div className="right-menubar">
                  <h3>Services</h3>
                  <ul>
                    {this.state.services.map(subnav => (
                      <li>
                        <a href={`/services-en/${subnav.slug}`}>{subnav.title}</a>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="about-company-right">
                  <div className="padding-top-middle" />

                  <CtaSidebar cta={this.state.cta} />

                  <div className="padding-top-middle" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {this.state.service.related ? (
          <div>
            <div className="padding-top-large" />
            <div className="business-portfolio-slider-2x">
              <div className="row">
                <div className="col-md-12">
                  <div className="portfolio-slider-content">
                    <div className="owl-carousel portfolio-slider-2">
                      {this.state.service.related.map(service => (
                        <div className="item">
                          <div className="hvrbox">
                            <img src={service.imgSmall} alt="Mountains" className="hvrbox-layer_bottom" />
                            <div className="hvrbox-layer_top hvrbox-text">
                              <div className="hvrbox-text">
                                <a href={service.imgLarge} data-fancybox-group="group2">
                                  <i className="fa fa-plus" />
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
}

export default Person;



// WEBPACK FOOTER //
// ./src/components/Service.js